import { useMemo } from 'react'

import { DashboardShell } from '@/modules/dashboard/pages/components/DashboardShell/DashboardShell'

import { NoAccounts } from '@/components/@Shared/NoAccounts/NoAccounts'
import { Loader } from '@/components/Loader/Loader'

import { useBankingServiceBankingControllerGetAccounts } from '@/__generated__/queries'
import type { AccountData } from '@/__generated__/requests/types.gen'

export function Component() {
  const { data, isFetching, isLoading } =
    useBankingServiceBankingControllerGetAccounts()

  const userAccounts = useMemo<AccountData[]>(
    () => data?.accounts ?? [],
    [data],
  )

  if (isLoading || isFetching) {
    return <Loader isAuthenticatedLayout />
  }

  if (userAccounts.length) {
    return <DashboardShell />
  }

  return <NoAccounts />
}

Component.displayName = 'Dashboard'
